module.exports = __webpack_public_path__ + "static/media/team-dustin.495ef12e.jpg";